import { render, staticRenderFns } from "./FileUploadBox.vue?vue&type=template&id=bd2c3a5a&scoped=true&"
import script from "./FileUploadBox.vue?vue&type=script&lang=js&"
export * from "./FileUploadBox.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadBox.vue?vue&type=style&index=0&id=bd2c3a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2c3a5a",
  null
  
)

export default component.exports